var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DangerFill = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (_jsxs("svg", __assign({ width: '60', height: '60', viewBox: '0 0 60 60', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', onClick: onClick, className: className }, { children: [_jsx("g", __assign({ clipPath: 'url(#clip0_2453_4583)' }, { children: _jsx("path", { d: 'M30 0C13.425 0 0 13.425 0 30C0 46.575 13.425 60 30 60C46.575 60 60 46.575 60 30C60 13.425 46.575 0 30 0ZM45.95 41.55L41.525 45.975L30 34.425L18.45 45.975L14.025 41.55L25.575 30L14.05 18.45L18.475 14.025L30 25.575L41.55 14.025L45.975 18.45L34.425 30L45.95 41.55Z', fill: '#C12725' }) })), _jsx("defs", { children: _jsx("clipPath", __assign({ id: 'clip0_2453_4583' }, { children: _jsx("rect", { width: '60', height: '60', fill: 'white' }) })) })] })));
};
export { DangerFill };
//# sourceMappingURL=DangerFill.js.map